<template>
<div>
  <div class="geodk-objekter-container" style="cursor: pointer;">
    <div class="geodk-object-list-container" @click="toggleExpanded">
      <div class="counter-container" v-if="numberOfSelectedObjekter">
        <div>
          <span v-if="expanded">
            <svg width="18px" height="11px" viewBox="0 0 18 11" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
                <g id="RetVejkode-UI-elementer" transform="translate(-896.000000, -1163.000000)" stroke="#FFFFFF" stroke-width="2.5">
                  <polyline id="Path-9-Copy" transform="translate(905.071068, 1165.071068) scale(-1, 1) rotate(-45.000000) translate(-905.071068, -1165.071068) " points="900.071068 1160.07107 900.071068 1170.07107 910.071068 1170.07107"></polyline>
                </g>
              </g>
            </svg>
          </span>
          <span v-else>{{numberOfSelectedObjekter}}</span>
        </div>
      </div>
      <GeoDkObjektList
        v-if="geoDkObjekter.length"
        :geoDkObjekterToShow="geoDkObjekterToShow"
        :removeItem="removeItem"
      />
    </div>
    <svg v-if="numberOfSelectedObjekter" width="230px" height="16px" viewBox="0 0 230 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="RetVejkode-UI-elementer" transform="translate(-1288.000000, -1532.000000)" fill="#FFA732" fill-rule="nonzero">
              <path d="M1389.07143,1535.93502 L1290,1535.93502 C1288.89543,1535.93502 1288,1535.03959 1288,1533.93502 L1288,1532 L1518,1532 L1518,1533.93502 C1518,1535.03959 1517.10457,1535.93502 1516,1535.93502 L1416.92857,1535.93502 L1404.35265,1547.48185 C1403.58766,1548.18425 1402.41234,1548.18425 1401.64735,1547.48185 L1389.07143,1535.93502 Z" id="Combined-Shape"></path>
          </g>
      </g>
    </svg>
    <div class="ny_vejkode">
      <div v-if="geoDkObjekter.length">
        <h1>Ret vejkode til</h1>
        <div id="vejkode-container">
          <VejkodeNumberInput :vejkode="this.vejkode" :onChange="onVejkodeInputChange" />
        </div>
        <div id="adressering">{{adressering}}</div>
      </div>
      <p v-else style="padding: 30px 20px 0 20px; text-align: center;" else>Vælg et vejstykke i kortet</p>
    </div>
    <svg width="230px" height="16px" viewBox="0 0 230 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="RetVejkode-UI-elementer" transform="translate(-1754.000000, -958.000000)" fill="#7938D0" fill-rule="nonzero">
                <path d="M1855.07143,961.935016 L1756,961.935016 C1754.89543,961.935016 1754,961.039585 1754,959.935016 L1754,958 L1984,958 L1984,959.935016 C1984,961.039585 1983.10457,961.935016 1982,961.935016 L1882.92857,961.935016 L1870.35265,973.481852 C1869.58766,974.184247 1868.41234,974.184247 1867.64735,973.481852 L1855.07143,961.935016 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </svg>
    <SendVejkodeButton
      :disabled="this.shoulDisableButton"
      :onButtonClick="this.confirmSubmit"
    />
  </div>
  <ConfirmationModal
    v-if="showModal"
    :geoDkObjekter="geoDkObjekter"
    :sendingToGeoDk="sendingToGeoDk"
    :close="closeModal"
    :sagId="sagId"
    :opdatering="opdatering"
    :adressering="adressering"
    :error="error"
    :currentVejkode="currentVejkode"
    :sendVejkode="sendVejkode"
  />
</div>
</template>

<script>
import GeoDkObjektList from './GeoDkObjektList.vue';
import VejkodeNumberInput from './VejkodeNumberInput.vue';
import SendVejkodeButton from './SendVejkodeButton.vue';
import GeoDkSimpleEditApi from '@/api/GeoDkSimpleEdit';
import ConfirmationModal from './ConfirmationModal';

export default {
  name: 'vejkode-container',
  components: {
    GeoDkObjektList,
    VejkodeNumberInput,
    SendVejkodeButton,
    ConfirmationModal,
  },
  props: {
    geoDkObjekter: Array,
    fetchedVejkoder: Object,
    adressering: String,
    onVejkodeChange: Function,
    vejkode: Number,
    reset: Function,
    removeItem: Function,
  },
  computed: {
    geoDkObjekterToShow () {
      const { geoDkObjekter, expanded } = this;
      if (!geoDkObjekter || expanded) {
        return geoDkObjekter;
      } else {
        return [geoDkObjekter[geoDkObjekter.length - 1]];
      }
    },
    numberOfSelectedObjekter () {
      return this.geoDkObjekter.length;
    },
    shoulDisableButton () {
      return this.geoDkObjekter.length === 0 ||
        (this.adressering.length === 0 && this.currentVejkode > 0);
    },
  },
  data: function () {
    return {
      expanded: false,
      currentVejkode: this.vejkode,
      showModal: false,
      opdatering: {},
      sendingToGeoDk: false,
      sagId: 0,
      error: '',
    };
  },
  methods: {
    confirmSubmit () {
      this.opdatering = {
        ObjektOpdateringer: this.geoDkObjekter.map(geodkObj => {
          return {
            GeodkobjektId: geodkObj.get('geoDkId'),
            Egenskabsopdateringer: {
              'vejkode': this.currentVejkode
                ? this.currentVejkode.toString().padStart(4, '0')
                : null,
            },
          };
        }),
        kommentar: '',
      };
      this.showModal = true;
    },
    sendVejkode () {
      if (this.adressering || !this.currentVejkode) {
        this.sendingToGeoDk = true;
        GeoDkSimpleEditApi.postVejkodeOpdatering(this.opdatering, localStorage.getItem('token'))
          .then(sagId => {
            if (sagId.Message) {
              throw new Error(sagId.Message);
            }
            this.sagId = sagId;
            this.reset();
            this.sendingToGeoDk = false;
          })
          .catch(error => {
            console.log(error);
            this.sendingToGeoDk = false;
            this.error = error.toString();
          });
      } else {
        console.log('ugyldig vejkode');
      }
    },
    toggleExpanded () {
      this.expanded = !this.expanded;
    },
    setCurrentVejkode (vejkode) {
      this.currentVejkode = parseInt(vejkode);
      this.onVejkodeChange(vejkode);
    },
    onVejkodeInputChange (value) {
      // validate that value is defined, larger than 0 and only contains numbers
      this.setCurrentVejkode(value);
      this.onVejkodeChange(value);
    },
    closeModal (reset) {
      if (reset) {
        this.reset();
      }
      this.showModal = false;
      this.sendingToGeoDk = false;
      this.sagId = 0;
      this.error = '';
    },
  },
};
</script>

<style lang=scss scoped>
.geodk-objekter-container {
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 10px; /* Erstatter right og bottom med padding for at skygge skal fungere */
  width: 240px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 2;
  -webkit-transform: translateZ(1px); /* z-index not working on iOS */
  font-size: 16px;
  padding-top: 20px;
  cursor: auto;
  text-align: center;
  overflow: hidden;
}

.geodk-object-list-container {
  overflow-y: auto;
  max-height: calc(100vh - 340px);
  margin: 0 -10px;
  padding: 0 10px;
}

#opdater_vejkoder,
.geodk-objekter-header {
  font-size: 20px;
}
.kategori {
  font-size: 12px;
}

.ny_vejkode {
  margin-top: 7px;
  padding: 20px;
  background-color: #FFFFFF;
  cursor: auto;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content:space-around; */
  box-shadow: 0 2px 10px 0 rgba(92,109,150,0.30);
  border-radius: 2px;
}
.ny_vejkode h1{
  text-transform: uppercase;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #838383;
  margin: 0;
}

#adressering{
  color: rgba(0,0,0,0.7);
  font-size: 12px;
  letter-spacing: -0.74px;
  font-weight: 600;
  color: #8d8d8d;
}

.arrow-down{
  width: 0;
  height: 0;
  left: 50%;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid rgba(0, 0, 0, 1);
  margin: -1px auto;
  filter: drop-shadow(0.125rem 0.125rem 0.75rem rgba(0, 0, 0, 0.15));
}

.counter-container {
  /* border: rgba(255, 144, 0, 1) thin solid; */
  background-color: $selected-color;
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  position:absolute;
  right: 5px;
  top: 5px;
  z-index: 3;
  color: #FFFFFF;
  font-size: 18;
  font-weight: 600;
}

.counter span {
  margin: 0;
  text-align: center;
}

svg {
  width: 220px;
}
</style>
